

























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import { getMaterials } from '@/services/materials';
import BaseComponent from '@/components/base-component.vue';
import InputMoney from '@/components/UI/input-money.vue';
import { sortKey } from '@/helpers/sort';
import IMaterial from '@/interfaces/material';
import { toNumber } from '@/helpers/toNumber';

@Component({
  components: { InputMoney },
})
export default class ProductMaterialForm extends BaseComponent {
  @Prop()
  public isEdit: boolean;
  @Prop()
  public editItem: any;

  @Prop({default:true})
  public showQtdeReferencia: boolean

  public form: any = {
    valid: false,
    rules: {
      material: [(v) => !!v || 'Selecione um ativo'],
      amount: [(v) => (!!v && toNumber(v) > 0) || 'Digite uma quantidade'],
      reference_unit: [(v) => (!this.showQtdeReferencia || !!v) || 'Digite uma referência'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: any = {};

  public materials: IMaterial[] = [];

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.$refs.form.resetValidation();
    this.item = {};
    if (!val) {
      return;
    }

    this.item = cloneDeep(this.editItem); // Clones the Prop into the model
  }

  public async beforeMount(): Promise<void> {
    this.getMaterials();
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    let item = this.item;
    const payload = {
      descricao: this.materials.find(m => m.id == item.idInsumo).descricao,
      idInsumo: item.idInsumo,
      quantidade: item.quantidade,
      quantidadeReferencia: item.quantidadeReferencia,
      key: item.key
    }; 
    this.$emit('save', payload);
    this.$refs.form.resetValidation();
  }

  public closeForm(): void {
    const closeAction = () => {
      this.$emit('close');
      this.$refs.form.resetValidation();
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }

  private getMaterials(): void {
    getMaterials().subscribe((data) => {
      this.materials = data
        .map((material) => {
          return {
            ...material,
            siglaUnidadeMedida: !!material.unidadeMedida ? material.unidadeMedida.sigla : null,
            descricao: !!material.unidadeMedida
              ? `${material.descricao} (${material.unidadeMedida.sigla})`
              : material.descricao,
          };
        })
        .sort(sortKey('descricao'));
    });
  }
}
